function getApiBaseUrl(): string {
	// Check for environment variable or use window location
	const hostname = window.location.hostname;

	if (hostname === 'localhost') {
		return 'http://localhost:5173';
	}

	if (hostname === 'staging.pandemic.poker') {
		return 'https://staging.pandemic.poker';
	}

	if (hostname === 'pandemic.poker') {
		return 'https://pandemic.poker';
	}

	// Default to current origin for development
	return window.location.origin;
}

function getWebSocketUrl(): string {
	const baseUrl = getApiBaseUrl();
	return baseUrl.replace('http', 'ws');
}

export const apiConfig = {
	baseUrl: getApiBaseUrl(),
	websocketUrl: getWebSocketUrl(),
	endpoints: {
		auth: '/api/auth',
		lobby: '/api/lobby',
		matchmaking: '/api/matchmaking',
		game: '/api/game',
		health: '/api/health',
	},
};
